// extracted by mini-css-extract-plugin
export default {"main_div":"demo_main_div__VSgyl","left_div":"demo_left_div__Zyemi","right_div":"demo_right_div__Y10oz"};